var _rect, _path, _rect2, _rect3, _rect4, _path2, _g, _rect5, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 41,
    viewBox: "0 0 173 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24,
    width: 167,
    height: 5,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 24H27V29H0L3 24Z",
    fill: "#2CB8D7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    width: 14,
    height: 5,
    fill: "#CCE52E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 24,
    width: 33,
    height: 5,
    fill: "#F1C425"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 24,
    width: 18,
    height: 5,
    fill: "#FD8F29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24H170L173 29H92V24Z",
    fill: "#EE484E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_537)",
    filter: "url(#filter0_d_268_537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7404 25.1657L41.3119 32.5941C41.2582 32.7124 41.2902 32.8535 41.3919 32.9358C41.4936 33.0187 41.6382 33.0215 41.7427 32.9427L44.9998 30.4999L48.2569 32.9427C48.3614 33.0215 48.5066 33.0187 48.6077 32.9364C48.6769 32.881 48.714 32.7981 48.714 32.7141C48.714 32.6735 48.7054 32.633 48.6877 32.5947L45.2592 25.1663C45.2124 25.0646 45.1112 25 44.9998 25C44.8884 25 44.7872 25.0646 44.7404 25.1657Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 65,
    height: 18,
    rx: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.67 9.99V7.61C23.67 6.48 22.93 5.52 21.86 5.52H21.31C20.24 5.52 19.5 6.48 19.5 7.61V9.99C19.5 11.12 20.24 12.08 21.31 12.08H21.86C22.93 12.08 23.67 11.12 23.67 9.99ZM22.27 9.95C22.27 10.64 21.98 10.93 21.63 10.93H21.53C21.18 10.93 20.9 10.64 20.9 9.95V7.65C20.9 6.96 21.19 6.67 21.54 6.67H21.64C21.99 6.67 22.27 6.96 22.27 7.65V9.95ZM26.1663 11.34C26.1663 10.96 25.9263 10.6 25.3663 10.6C24.8063 10.6 24.5663 10.96 24.5663 11.34C24.5663 11.72 24.8063 12.08 25.3663 12.08C25.9263 12.08 26.1663 11.72 26.1663 11.34ZM31.1981 7.26V6.81C31.1981 6.08 30.5881 5.52 29.8581 5.52H28.6281C28.3681 5.52 28.1081 5.57 27.8681 5.68L27.1781 5.98L27.2881 7.14L28.0781 6.81C28.2781 6.73 28.4581 6.67 28.7081 6.67H29.4981C29.7081 6.67 29.8281 6.78 29.8281 6.99V7.08C29.8281 7.19 29.7781 7.28 29.7181 7.34L27.6081 9.45C27.4181 9.64 27.1681 10.04 27.1681 10.46V12H31.1181V10.85H28.6181L28.5581 10.79V10.61C28.5581 10.5 28.6081 10.42 28.6681 10.36L30.7581 8.26C30.9481 8.07 31.1981 7.68 31.1981 7.26ZM36.2844 6.85V5.6H32.0944V6.75H34.8244L34.8844 6.81V7.04C34.8844 7.14 34.8344 7.28 34.7944 7.34L33.5044 9.29C33.3444 9.54 33.2744 9.87 33.2744 10.24V12H34.6744V10.25C34.6744 10.08 34.7244 9.81 34.7944 9.71L36.0544 7.8C36.2144 7.55 36.2844 7.22 36.2844 6.85ZM41.5406 10.6V9.8C41.5406 9.29 41.4206 8.99 41.2106 8.68L40.6606 7.87H38.9006L39.0006 6.75H41.3306V5.6H37.7206L37.4306 8.75L37.6906 9.02H39.8506L39.9406 9.14C40.0706 9.31 40.1406 9.5 40.1406 9.74V10.54C40.1406 10.84 39.9506 10.93 39.7806 10.93H38.8506C38.6806 10.93 38.5906 10.9 38.4406 10.84L37.4806 10.46L37.3806 11.61L38.1606 11.95C38.3206 12.02 38.5606 12.08 38.7706 12.08H39.9606C40.8806 12.08 41.5406 11.37 41.5406 10.6ZM46.6969 10.6V9.8C46.6969 9.29 46.5769 8.99 46.3669 8.68L45.8169 7.87H44.0569L44.1569 6.75H46.4869V5.6H42.8769L42.5869 8.75L42.8469 9.02H45.0069L45.0969 9.14C45.2269 9.31 45.2969 9.5 45.2969 9.74V10.54C45.2969 10.84 45.1069 10.93 44.9369 10.93H44.0069C43.8369 10.93 43.7469 10.9 43.5969 10.84L42.6369 10.46L42.5369 11.61L43.3169 11.95C43.4769 12.02 43.7169 12.08 43.9269 12.08H45.1169C46.0369 12.08 46.6969 11.37 46.6969 10.6ZM51.7531 6.85V5.6H47.5631V6.75H50.2931L50.3531 6.81V7.04C50.3531 7.14 50.3031 7.28 50.2631 7.34L48.9731 9.29C48.8131 9.54 48.7431 9.87 48.7431 10.24V12H50.1431V10.25C50.1431 10.08 50.1931 9.81 50.2631 9.71L51.5231 7.8C51.6831 7.55 51.7531 7.22 51.7531 6.85ZM57.0294 12V10.85H55.8294L55.7694 10.79V5.52H54.4394C54.2294 5.52 53.9194 5.59 53.7594 5.65L52.8594 5.97L52.9594 7.06L54.0294 6.73C54.1594 6.69 54.2594 6.68 54.3694 6.67V10.79L54.3094 10.85H52.9894V12H57.0294ZM62.2356 9.99V9.2C62.2356 8.32 61.7656 7.83 60.9256 7.88L59.5256 7.97L59.4656 7.91V7C59.4656 6.79 59.5756 6.67 59.7856 6.67H60.3956C60.6456 6.67 60.8256 6.7 61.0256 6.77L61.8156 7.04L61.9256 5.87L61.2356 5.64C60.9856 5.56 60.7356 5.52 60.4756 5.52H59.3756C58.6256 5.52 58.0656 6.08 58.0656 6.84V9.99C58.0656 11.12 58.8056 12.08 59.8756 12.08H60.4256C61.4956 12.08 62.2356 11.12 62.2356 9.99ZM60.8356 9.95C60.8356 10.64 60.5456 10.93 60.1956 10.93H60.0956C59.7456 10.93 59.4656 10.64 59.4656 9.95V9.16L59.5256 9.1L60.5156 9.01C60.7156 8.99 60.8356 9.13 60.8356 9.34V9.95ZM64.6819 11.34C64.6819 10.96 64.4419 10.6 63.8819 10.6C63.3219 10.6 63.0819 10.96 63.0819 11.34C63.0819 11.72 63.3219 12.08 63.8819 12.08C64.4419 12.08 64.6819 11.72 64.6819 11.34ZM67.1038 11.34C67.1038 10.96 66.8638 10.6 66.3038 10.6C65.7438 10.6 65.5038 10.96 65.5038 11.34C65.5038 11.72 65.7438 12.08 66.3038 12.08C66.8638 12.08 67.1038 11.72 67.1038 11.34ZM69.5256 11.34C69.5256 10.96 69.2856 10.6 68.7256 10.6C68.1656 10.6 67.9256 10.96 67.9256 11.34C67.9256 11.72 68.1656 12.08 68.7256 12.08C69.2856 12.08 69.5256 11.72 69.5256 11.34Z",
    fill: "#1C1D24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_268_537",
    x: 37,
    y: 25,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_268_537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_268_537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(41 33) rotate(-90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloat);
export default __webpack_public_path__ + "static/media/float.2868cad4ba2a801f80bbe0ee25f151ca.svg";
export { ForwardRef as ReactComponent };